import { useState } from "react";

export const useBoolean = (): [boolean, () => void, () => void] => {
  const [boolean, setBoolean] = useState(false);

  const startBoolean = () => setBoolean(true);

  const stopBoolean = () => setBoolean(false);

  return [boolean, startBoolean, stopBoolean];
};
